/**
 * @generated SignedSource<<b6d6085360d9c4a270cfb969dbbb1d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleUtilsArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleUtilsArticle";
};
export type articleUtilsArticle$key = {
  readonly " $data"?: articleUtilsArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "articleUtilsArticle"
};

(node as any).hash = "78a8e32f99b01992bc7ef803dae0d119";

export default node;
